
import InlineDialog from '@/components/info/InlineDialog.vue';
import { Icon } from '@/lib/enum/Icon';
import { Entity } from '@/lib/realtime/RealtimeEntity';
import { realtimeQuery } from '@/lib/realtime/weak/realtimeFunctions';
import { presentShiftTimes } from '@/lib/schedule-v2/scheduleV2Functions';
import { shiftJobRoleIsVisible } from '@/lib/schedule-v2/shiftV2Functions';
import { getEntity } from '@/util/entityFunctions';
import DateSquareV2 from '@/views/schedule/components/DateSquareV2.vue';
import ShiftDetails from '@/views/schedule/components/ShiftDetails.vue';
import { PropType } from 'vue';
import { JobRole, Location, Shift } from '../../../../../api/v1';
import Button from '../../../../components/buttons/Button.vue';

export default {
  name: 'OpenShiftResponseDetails',
  components: { Button, DateSquareV2, ShiftDetails, InlineDialog },
  props: {
    shift: {
      type: Object as PropType<Shift>,
      required: true,
    },
    conflictMessage: {
      type: Object as PropType<{ header: string; body: string } | null>,
      default: null,
    },
  },
  data() {
    return {
      Icon,
      detailsOpen: false,
    };
  },
  computed: {
    shiftTimes() {
      return presentShiftTimes(this.shift);
    },

    jobRole(): JobRole | null {
      return (
        realtimeQuery(Entity.JobRole)
          .where('id', 'eq', this.shift.jobRoleId)
          .fetch().data[0] ?? null
      );
    },

    location(): Location | null {
      return (
        realtimeQuery(Entity.Location)
          .where('id', 'eq', this.shift.locationId)
          .fetch().data[0] ?? null
      );
    },
  },
  methods: { getEntity, shiftJobRoleIsVisible },
};
